import TextField from "@material-ui/core/TextField";
import React from "react";
import NumberFormat from "react-number-format";

const CustomNumberFormat = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      value={props.value}
      name={props.name}
      onBlur={props.onBlur}
      prefix={"R$"}
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      isNumericString={true}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const CurrencyField = ({ field, onChange, ...props }) => {
  const handleChange = (event) => {
    const targetValue = event.target.value;

    props.form.setFieldValue(field.name, targetValue);
    onChange?.call(null, event);
  };

  return (
    <TextField
      {...field}
      {...props}
      variant={props.variant || "standard"}
      fullWidth={props.fullWidth}
      label={props.label}
      onChange={handleChange}
      InputProps={{
        inputComponent: CustomNumberFormat,
      }}
    />
  );
};

export default CurrencyField;
